import { Grid, MenuItem } from '@material-ui/core';
import styled from 'styled-components';
import { GutterCSS } from 'styles/common';

export const ItemContainer = styled(Grid)`
  padding: 1rem 0.75rem;
  display: flex;
  align-items: center;
  ${GutterCSS};
  flex-basis: ${(props) => props.width || 'auto'};
  border-right: 1px solid ${(props) => props.theme.palette.borders.lightGrey};
  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.palette.background.lightGrey};
  }
  &:hover * {
    cursor: pointer;
  }
  opacity: ${({ disabled }) => (disabled ? '0.5' : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  cursor: ${({ disabled }) => (disabled ? 'none' : 'pointer')};
`;
export const SelectedCounter = styled.span`
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 0.3rem 0.5rem;
  color: white;
  margin-left: 0.25rem;
  border-radius: 4px;
`;

export const ScrollableContainer = styled.div`
  max-height: 40vh;
  overflow-y: auto;
`;

export const ApplyMenuItem = styled(MenuItem)`
  padding-top: 1rem;
`;
